import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 1300px;
  padding-bottom: 40px;

  .dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    flex-wrap: wrap;
    gap: 20px;

    h1 {
      margin: 0;
      font-size: 28px;
      color: #1a1a1a;
      font-weight: 800;
    }
  }

  .section-title {
    font-size: 20px;
    font-weight: 700;
    color: #333;
    margin: 40px 0 20px 0;
    display: flex;
    align-items: center;
    gap: 12px;

    &::after {
      content: "";
      flex: 1;
      height: 1px;
      background: #eee;
    }
  }

  .main-tags {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 30px;

    @media (max-width: 1100px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 700px) {
      grid-template-columns: 1fr;
    }
  }

  .tag-item {
    background: #fff;
    padding: 25px;
    border-radius: 20px;
    border: 1px solid #f0f0f0;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
    display: flex;
    flex-direction: column;
    gap: 8px;

    .tag-header {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      color: #666;
      font-weight: 500;
    }

    .value {
      font-size: 28px;
      font-weight: 800;
      color: #1a1a1a;
    }

    &.highlight {
      border-left: 5px solid #008037;
      .value {
        color: #008037;
      }
    }
    &.warning {
      border-left: 5px solid #f2760a;
      .value {
        color: #f2760a;
      }
    }
    &.blue {
      border-left: 5px solid #1890ff;
      .value {
        color: #1890ff;
      }
    }
  }

  .rankings-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 25px;
    margin-bottom: 40px;
  }

  .ranking-card {
    background: #fff;
    border-radius: 20px;
    padding: 25px;
    border: 1px solid #f0f0f0;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);

    h3 {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 20px;
      color: #333;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .ranking-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .ranking-item {
      display: flex;
      align-items: center;
      gap: 15px;
      padding: 10px;
      border-radius: 12px;
      transition: background 0.2s;

      &:hover {
        background: #f9f9f9;
      }

      .position {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 800;
        font-size: 14px;
        background: #eee;
        color: #666;

        &.pos-1 {
          background: #ffd700;
          color: #fff;
        }
        &.pos-2 {
          background: #c0c0c0;
          color: #fff;
        }
        &.pos-3 {
          background: #cd7f32;
          color: #fff;
        }
      }

      .associate-info {
        flex: 1;
        display: flex;
        flex-direction: column;

        strong {
          font-size: 14px;
          color: #333;
        }
        span {
          font-size: 12px;
          color: #999;
        }
      }

      .score {
        font-weight: 800;
        color: #008037;
        font-size: 16px;
      }
    }
  }

  .table-container {
    background: #fff;
    border-radius: 20px;
    padding: 25px;
    border: 1px solid #f0f0f0;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
  }
`;
